import React from "react";
import { ArrowRight, MessageSquareText } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useShareFeedback } from "../FeedbackDialog";

export default function ProcessFeedbackBanner() {
  const { t } = useTranslation();
  const shareFeedback = useShareFeedback();
  if (!shareFeedback) return null;
  return (
    <aside className="mt-5 flex flex-wrap items-center gap-4 rounded-xl border border-amber-500/15 bg-amber-500/5 px-5 py-4">
      <MessageSquareText aria-hidden="true" className="h-8 w-8 shrink-0 text-amber-500" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-text">{t("process_directory.feedback_title")}</p>
        <p className="mt-1 text-xs text-text-mid">{t("process_directory.feedback_hint")}</p>
      </div>
      <button
        type="button"
        onClick={shareFeedback}
        className="inline-flex cursor-pointer items-center gap-3 rounded-lg border border-info/40 bg-surface px-4 py-2.5 text-sm font-medium text-info hover:bg-info/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info/30"
      >
        {t("process_directory.feedback_action")}
        <ArrowRight aria-hidden="true" className="h-4 w-4" />
      </button>
    </aside>
  );
}
